import { Star } from "lucide-react";
import { REVIEWS } from "@/lib/data";
import { Reveal, MaskedLines } from "./motion";

export default function Reviews() {
  return (
    <section id="recensioni" className="relative bg-bone py-24 sm:py-32 grain">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-xs tracking-[0.25em] uppercase font-sans font-semibold text-terracotta">
            Recensioni
          </span>
          <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-charcoal">
            <MaskedLines lines={["Le parole dei"]} />
            <MaskedLines lines={["nostri ospiti."]} lineClassName="italic text-terracotta" delay={0.1} />
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={`${r.author}-${i}`} delay={i * 0.07}>
              <figure className="h-full bg-sand rounded-sm p-8 sm:p-10 flex flex-col justify-between hover:-translate-y-1 transition-transform duration-500">
                <div>
                  <div className="flex gap-1 mb-5 text-terracotta">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                    ))}
                  </div>
                  <blockquote className="font-serif text-2xl sm:text-[27px] leading-snug text-charcoal">
                    “{r.text}”
                  </blockquote>
                </div>
                <figcaption className="mt-8 font-sans text-sm">
                  <span className="font-semibold text-charcoal">{r.author}</span>
                  <span className="text-pebble"> · {r.from}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
